// extracted by mini-css-extract-plugin
export default {"white":"#fff","notificationRed":"#ff4c68","primaryIcon":"#309df0","AdSlotBranding__desktopWrap":"bha_a","AdSlotBranding__desktop":"bha_b","AdSlotBranding__mobile":"bha_c"};